import React from "react";

/** Original CHILLWOAH mark — C arc embracing a W (CHILL + WOAH). */
export function LogoMark({ size = 36, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      className={className}
      role="img"
      aria-label="CHILLWOAH logo mark"
    >
      <rect width="64" height="64" rx="12" fill="#08080A" />
      <path d="M46 17 A 21 21 0 1 0 46 47" fill="none" stroke="#F26522" strokeWidth="7" strokeLinecap="round" />
      <path
        d="M19 30 L26 44 L32.5 32 L39 44 L46 30"
        fill="none"
        stroke="#F8F9FA"
        strokeWidth="5.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Wordmark({ className = "" }) {
  return <span className={`font-display font-extrabold tracking-tight ${className}`}>CHILLWOAH</span>;
}
